<template>
  <b-modal id="modal-confirm-switch-page" header-class="warning" no-close-on-esc no-close-on-backdrop>
    <template #modal-header="{ close }">
      <div class="d-inline-flex justify-content-between w-100">
        <div class="w-100">
          <div class="fs-db-28"> {{ $t('engine.managePage.pageDuplicateSwitch.lblTitle',languageEngine) }} </div>
        </div>
      </div>
      <div
        @click="close(),$emit('clear')"
        type="button"
        aria-label="Close"
        id="close-modal-confirm-switch-page"
        class="close-modal"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div class="fs-sa-16">
        <span class="text-primary">  {{ $t('engine.managePage.pageDuplicateSwitch.lblPage',languageEngine) }}: {{ namePage }} </span>  
        {{ $t('engine.managePage.pageDuplicateSwitch.lblText1',languageEngine) }}
        <span class="text-primary"> {{ lang.toUpperCase() }} {{ languageEngine !== 'th' ? $t('engine.managePage.pageDuplicateSwitch.lblText2',languageEngine) : '' }}</span>.
      </div>
      <div class="fs-sa-16">{{ $t('engine.managePage.pageDuplicateSwitch.lblText3',languageEngine) }}</div>
    </template>
    <template #modal-footer>
      <b-button variant="blue" @click="confirm">
        {{ $t('engine.managePage.pageDuplicateSwitch.lblSwitch',languageEngine) }}
        <i :class="`flag-icon flag-icon-${flag}`"></i>
        {{ lang.toUpperCase() }}
        <!-- {{ lang == 'th' ? $t('engine.managePage.pageDuplicateSwitch.lblText5',languageEngine) : '' }} -->
      </b-button>
      <b-button variant="default" @click="closeModal">
       {{ $t('engine.managePage.pageDuplicateSwitch.lblText6',languageEngine) }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    closeModal() {
      this.$emit("clear");
      this.$bvModal.hide("modal-confirm-switch-page");
    },
    confirm() {
      this.$store.dispatch("designIframe/page/initLanguage", {
        language: this.lang,
      });
      this.$store.dispatch("design/site/setLanguageUse", {
        language: this.lang,
      });
      this.$store.dispatch("designIframe/page/getSiteMetadata", {
        lang: this.lang,
      });
      this.$store.dispatch("designIframe/page/getPage", {
        metaDataID: this.metaDataID,
        lang: this.lang,
      });

      this.$emit("clear");
      this.$bvModal.hide("modal-confirm-switch-page");
      this.$bvModal.hide("modal-manage-page");
    },
  },
  computed :{
    ...mapGetters({ 
      languageEngine: "design/userPreference/languageEngine",
    })
  },
  props: {
    namePage: {
      type: String,
      default: "",
    },
    lang: {
      type: String,
      default: "",
    },
    flag: {
      type: String,
      default: "",
    },
    metaDataID: {
      type: String,
      default: "",
    },
  },
};
</script>

<style></style>
